import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { isAnyFilterActive, getQueryParamNames } from '../../../util/search';

import PopupOpenerButton from '../PopupOpenerButton/PopupOpenerButton';

import css from './SearchFiltersPrimary.module.css';
import IconCard from '../../../components/SavedCardDetails/IconCard/IconCard';
import { IconSpinner } from '../../../components';

/**
 * SearchFiltersPrimary component
 *
 * @component
 * @param {Object} props
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {React.Node} props.children - The children
 * @param {boolean} [props.isSecondaryFiltersOpen] - Whether the secondary filters are open
 * @param {Function} [props.toggleSecondaryFiltersOpen] - The function to toggle the secondary filters
 * @param {number} [props.selectedSecondaryFiltersCount] - The number of selected secondary filters
 * @returns {JSX.Element}
 */
const SearchFiltersPrimaryComponent = props => {
  const {
    rootClassName,
    className,
    children,
    isSecondaryFiltersOpen = false,
    toggleSecondaryFiltersOpen = null,
    selectedSecondaryFiltersCount = 0,
    urlQueryParams,
    filterConfigs,
    searchInProgress,
    totalItems,
    resetAll,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  // Check if any filters (from config) are active in URL params
  const { listingFieldsConfig, defaultFiltersConfig } = filterConfigs || {};
  const allFilterKeys =
    listingFieldsConfig && defaultFiltersConfig
      ? getQueryParamNames(listingFieldsConfig, defaultFiltersConfig)
      : [];
  const arePrimaryFiltersActive = isAnyFilterActive(allFilterKeys, urlQueryParams, filterConfigs);

  const toggleSecondaryFiltersOpenButton = toggleSecondaryFiltersOpen ? (
    <PopupOpenerButton
      isSelected={isSecondaryFiltersOpen || selectedSecondaryFiltersCount > 0}
      toggleOpen={() => {
        toggleSecondaryFiltersOpen(!isSecondaryFiltersOpen);
      }}
    >
      <FormattedMessage
        id="SearchFiltersPrimary.moreFiltersButton"
        values={{ count: selectedSecondaryFiltersCount }}
      />
    </PopupOpenerButton>
  ) : null;

  return (
    <div className={classes}>
      <div className={css.filters}>
        {children}
        {toggleSecondaryFiltersOpenButton}
        {/* clear btn */}
        {arePrimaryFiltersActive && (
          <button
            type='button'
            className={classNames(css.clearBtn, { [css.clearBtnActive]: arePrimaryFiltersActive })}
            onClick={e => resetAll(e)}
          >
            <FormattedMessage id="MainPanelHeader.clear" /><IconCard brand='close' />
          </button>
        )}
      </div>
      
      {/* total listing */}
      <div className={css.totalCount}>
        <div className={css.searchOptions}>
          <span className={css.totalCount}>
            <h5>
              {searchInProgress ? (
                // <FormattedMessage id="MainPanelHeader.loadingResults" />
                <IconSpinner />
              ) : (
                <FormattedMessage
                  id="MainPanelHeader.foundResults"
                  values={{ count: totalItems }}
                />
              )}
            </h5>
          </span>
        </div>
      </div>
    </div>
  );
};

const SearchFiltersPrimary = SearchFiltersPrimaryComponent;

export default SearchFiltersPrimary;
